import React from "react";
import ajax from "./../../lib/ajax.js";
import moment from "moment";
import context from "../../lib/context.js";

export default class TaskDurationList extends React.Component {
    constructor(props) {
        super(props);
        this.editItem = this.editItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }

    editItem(timecardLineDetailId) {
        if (this.props.onEditItem)
            this.props.onEditItem(timecardLineDetailId);
    }

    deleteItem(timecardLineDetailId) {
        const self = this;
        context.message({
            show :true,
            type : "info",
            message: "Are you sure you want to delete this record?",
            buttons: "yes,no"
        }, function(button, s) {
            // s is timecardLineDetailId, timecardLineDetailId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type:"loading",
                    message: "Deleting. Please wait..."            
                });
                ajax.api()
                    .delete("delete-durationtc/" + s)
                    .then(function(res) {
                        context.message({show: false});
                        if (self.props.onDeletedItem) 
                            self.props.onDeletedItem(self.props.dayId, self.props.placementTaskCode);
                    })
                    .catch(function(err) {
                        const message = err.response.data.message;
                        context.message({
                            show :true,
                            type : "error",
                            message: message,
                            buttons: "close"});
                    }); 
            }
        }, timecardLineDetailId);
    }

    render() {
        let items = [];
        let itemsMobile = [];
        let allowEdit = `${this.props.allowEdit}` == "true";

        let itemsEditButton = allowEdit ? "ap-duration-list-item-icon" : "ap-hidden";
        let itemsMobileEditButton = allowEdit ? "ap-duration-list-item-icon-mobile" : "ap-hidden";
        
        let vm = this.props.vm; // Expected to be an array of listItem 
        if (vm == null || vm == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    No Items Found!
                </div>
                );
        } else {
            for(let i=0; i<vm.length; i++) {
                let dataItem = vm[i];
                items.push(
                    <tr className="ap-duration-list-item">
                        <td className="">
                            {moment(vm[i].workDate).format("MM/DD/YYYY")}
                        </td>
                        <td className="ap-wrap-text">
                            {vm[i].placementTaskValue}
                        </td>
                        <td className="ap-truncate-text">
                            {vm[i].comment}
                        </td>
                        <td className="">
                            {vm[i].workTime.toFixed(2)}
                        </td>
                        <td className="ap-unwrap-content">
                            <span className={itemsEditButton}>
                                <a onClick={() => this.editItem(vm[i].timecardDetailLineId)}><i className='fa fa-pencil-square-o'></i></a>
                            </span>                    
                            <span className={itemsEditButton}>
                                <a onClick={() => this.deleteItem(vm[i].timecardDetailLineId)}><i className='fa fa-trash-o'></i></a>
                            </span>
                        </td>
                    </tr> 
                    );

                itemsMobile.push(
                    <div className="ap-duration-list-item-mobile">
                        <div className="row">
                            <div className="col-xs-2 col-sm-2">
                                Date:
                            </div>
                            <div className="col-xs-8 col-sm-8">
                                {moment(vm[i].workDate).format("MMM D, YYYY")}
                            </div>
                            <div className="col-md-2 col-lg-2 ap-unwrap-content">
                                <span className={itemsMobileEditButton}>
                                    <a onClick={() => this.editItem(vm[i].timecardDetailLineId)}><i className='fa fa-pencil-square-o'></i></a>
                                </span>                    
                                <span className={itemsMobileEditButton}>
                                    <a onClick={() => this.deleteItem(vm[i].timecardDetailLineId)}><i className='fa fa-trash-o'></i></a>
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-2 col-sm-2">
                                Task:
                            </div>
                            <div className="col-xs-10 col-sm-10 ap-truncate-text">
                                {vm[i].placementTaskValue}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-2 col-sm-2">
                                Worked:
                            </div>
                            <div className="col-xs-10 col-sm-10">
                                {vm[i].workTime.toFixed(2)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-2 col-sm-2">
                                Note:
                            </div>
                            <div className="col-xs-10 col-sm-10 ap-truncate-text">
                                {vm[i].comment}
                            </div>
                        </div>
                    </div> 
                    ); 
                }

        return(
            <div>
                <div className="ap-duration-list-container hidden-sm hidden-xs">
                    <table className="ap-duration-list">
                        <thead>
                            <tr className="ap-duration-list-header">
                                <th style={{width: "80px"}}>Date</th>
                                <th style={{width: "140px"}}>Task</th>
                                <th>Note</th>
                                <th style={{width: "65px"}}>Worked</th>
                                <th style={{width: "60px"}}>&nbsp;</th>
                            </tr>
                        </thead>

                        <tbody>
                            {items}
                        </tbody>
                    </table>
                </div>
                
                <div className="ap-duration-list-container hidden-md hidden-lg">
                    {itemsMobile}
                </div>
            </div>
                );
        }
    }
}